import { render, staticRenderFns } from "./multiplePagesMovingComponent.vue?vue&type=template&id=7b264224&"
import script from "./multiplePagesMovingComponent.vue?vue&type=script&lang=js&"
export * from "./multiplePagesMovingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports